import React, { useState, useMemo } from 'react'
import omit from 'lodash/omit'
import {
   Typography,
   Button,
   FormControl,
   FormControlLabel,
   InputLabel,
   FormLabel,
   RadioGroup,
   Radio,
   Select,
   OutlinedInput,
   FormHelperText,
   MenuItem,
   TextField
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import TooltipInputError from '../../toolTip/ToolTipInputError'
import { Autocomplete } from '@material-ui/lab'
import Utils from 'utils/utils'
import TRANSLATE, { VALUES, REGEXP } from 'utils/constants'

const useStyles = makeStyles(theme => ({
   formContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '95%',
      margin: '0 auto 10px'
   },
   formControl: {
      width: '100%',
      minWidth: 120,
      textAlign: 'initial',
      fontSize: 14,
      '&:not(:first-child)': {
         marginTop: 20
      }
   },
   formControlTextArea: {
      width: '100%',
      minWidth: 120,
      textAlign: 'initial',
      fontSize: '14px',
      '&:not(:first-child)': {
         marginTop: 20
      }
   },
   button: {
      width: '100%',
      height: 40,
      marginTop: 20,
      color: 'white',
      background: '#3264DC'
   },
   formCleanButton: {
      color: '#3264DC',
      border: '1px solid #3264DC',
      fontWeight: 'bold',
      marginTop: 20,
      width: '100%'
   },
   helperText: {
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      fontSize: 11
   },
   selectEmpty: {
      marginTop: theme.spacing(2)
   },
   disabledButton: {
      backgroundColor: '#12B3F9!important',
      opacity: '0.3',
      color: '#fff!important'
   },
   MuiFormHelperText: {
      root: {
         margin: '0 !important'
      },
      margin: '0 !important'
   },
   chips: {
      display: 'flex',
      flexWrap: 'wrap'
   },
   chip: {
      margin: 2
   },
   multipleSelectLabel: {
      backgroundColor: 'white'
   },
   titleOne: {
      margin: '20px 0 15px 9px',
      fontStyle: 'normal',
      fontSize: 14,
      alignSelf: 'start',
      color: '#8A8FAB',
      fontWeight: 400
   }
}))

const NO_MORE_THAN_150_CHARACTERS = Utils.noMoreThanNCharacters(150)
const NO_MORE_THAN_50_CHARACTERS = Utils.noMoreThanNCharacters(50)

const INITIAL_FUNCTIONALITY_FORM_VALIDATION = {
   name: false,
   status: false,
   description: false,
   module: false,
   link: false,
   application: false
}

const validRequired = value => !value || value === ''

const validationsFields = {
   name: value => value.length > 50 || validRequired(value),
   // value.length > 150 || !REGEXP.VALIDATION_NAME.exec(value) || validRequired(value),
   description: value => value.length > 50 || validRequired(value),
   link: validRequired,
   module: validRequired,
   status: validRequired,
   application: validRequired
}

const FunctionalityForm = ({
   formData,
   setForm,
   modules,
   setModules,
   actionSubmit,
   formBehavior,
   cleanCallback,
   applications,
}) => {
   const classes = useStyles()

   const isSearch = useMemo(() => formBehavior === VALUES.FORM_BEHAVIOR.SEARCH, [formBehavior])

   const [invalid, setInvalid] = useState(INITIAL_FUNCTIONALITY_FORM_VALIDATION)

   const cleanForm = () => {
      cleanCallback()
      setInvalid(INITIAL_FUNCTIONALITY_FORM_VALIDATION)
   }

   function isApplicationEmpty() {
      return validRequired(formData.application)
   }

   const validateFields = (name, value) => {
      const isInvalidFn = name in validationsFields ? validationsFields[name] : () => {}
      const isInvalid = isInvalidFn(value)
      if (isInvalid) {
         setInvalid(inv => ({
            ...inv,
            [name]: true
         }))
      } else if (invalid[name]) {
         setInvalid(inv => ({
            ...inv,
            [name]: false
         }))
      }
   }

   const addValuesToMemory = e => {
      const { name, value } = e.target
      if (!isSearch) {
         validateFields(name, value)
      } else if (isSearch && name === 'module') {
         validateFields('module', value)
      }
      setForm(prevFormData => ({
         ...prevFormData,
         [name]: value
      }))
   }

   const registerFunctionalities = type => {
      let isInvalidField = false
      const formFields =
         type === VALUES.FORM_BEHAVIOR.REGISTER
            ? omit(INITIAL_FUNCTIONALITY_FORM_VALIDATION, 'status')
            : INITIAL_FUNCTIONALITY_FORM_VALIDATION
      const newValidations = {}
      for (const key in formFields) {
         const isInvalid = validationsFields[key](formData[key])
         newValidations[key] = isInvalid
         if (isInvalid && !isInvalidField) {
            isInvalidField = isInvalid
         }
      }
      if (isInvalidField) {
         setInvalid(prev => {
            return { ...prev, ...newValidations }
         })
      } else {
         actionSubmit(type)
      }
   }

   const actionSubmitEvent = e => {
      e.preventDefault()
      console.log('crar')
      actionSubmit('crear')
   }

   function cleanModule() {
      addValuesToMemory({
         target: {
            name: 'module',
            value: ''
         }
      })
      setInvalid(prev => {
         return { ...prev, module: false }
      })
      setModules([])
   }

   function onApplicationChange(e, newValue) {
      addValuesToMemory({
         target: {
            name: 'application',
            value: newValue
         }
      })
   }

   const [selectedValue, setSelectedValue] = useState('') // Estado para mantener el valor seleccionado

   const handleChange = event => {
      setSelectedValue(event.target.value) // Actualiza el valor seleccionado cuando cambia
   }

   return (
      <div className={classes.formContainer}>
         <Typography className={classes.titleOne}>
            <b> Completa los campos </b>{' '}
         </Typography>

         <form className={classes.formContainer}>
            <FormControl variant="outlined" size="small" className={classes.formControl} error={invalid.name}>
               <InputLabel htmlFor="outlined-adornment-amount">
                  {`Nombre del bucket ${!isSearch ? '*' : ''}`}
               </InputLabel>
               <OutlinedInput
                  error={invalid.name}
                  value={formData.name}
                  onChange={e => {
                     const value = e.target.value
                     setForm(prevFormData => ({
                        ...prevFormData,
                        name : value
                     }))
                  }}
                  name="name"
                  size="small"
                  label="Nombre del bucket "
                  inputProps={{ maxLength: 50 }}
                  endAdornment={
                     (invalid.name && <TooltipInputError title={'Ingrese un nombre valido'} />) ||
                     (formData.name.length === 50 && <TooltipInputError title={NO_MORE_THAN_50_CHARACTERS} />)
                  }
               />
               <FormHelperText className={classes.helperText}>
                  {invalid.name && 'El campo nombre del bucket es obligatorio'}
               </FormHelperText>
            </FormControl>

            <FormControl
               variant="outlined"
               size="small"
               className={classes.formControlTextArea}
               error={invalid.description}
            >
               <InputLabel htmlFor="outlined-adornment-amount">
                  {`Descripción del bucket ${!isSearch ? '*' : ''}`}
               </InputLabel>
               <OutlinedInput
                  error={invalid.description}
                  value={formData.description}
                  onChange={e => {
                     const value = e.target.value
                     setForm(prevFormData => ({
                        ...prevFormData,
                        description : value
                     }))
                  }}
                  label="Descripción del bucket  "
                  name="description"
                  endAdornment={
                     (invalid?.description && <TooltipInputError title={'Ingrese una descripcion valida'} />) ||
                     (formData?.description?.length === 50 && (
                        <TooltipInputError title={NO_MORE_THAN_50_CHARACTERS} />
                     ))
                  }
                  multiline
                  rows={4}
                  inputProps={{ maxLength: 50 }}
               />
               <FormHelperText className={classes.helperText}>
                  {invalid.description && 'El campo Descripción del bucket es obligatorio'}
               </FormHelperText>
            </FormControl>

            <FormControl variant="outlined" size="small" className={classes.formControl} error={invalid.name}>
               <InputLabel htmlFor="outlined-adornment-amount">
                  {`Aplicacion ${!isSearch ? '*' : ''}`}
               </InputLabel>
               <OutlinedInput
                  error={invalid.application}
                  value={formData.application}
                  onChange={e => {
                     const value = e.target.value
                     setForm(prevFormData => ({
                        ...prevFormData,
                        application : value
                     }))
                  }}
                  name="name"
                  size="small"
                  label="Aplicacion "
                  inputProps={{ maxLength: 50 }}
                  endAdornment={
                     (invalid.application && <TooltipInputError title={'Ingrese un nombre valido'} />) ||
                     (formData.application.length === 50 && <TooltipInputError title={NO_MORE_THAN_50_CHARACTERS} />)
                  }
               />
               <FormHelperText className={classes.helperText}>
                  {invalid.application && 'El campo aplicacion es obligatorio'}
               </FormHelperText>
            </FormControl>



            <FormControl className={classes.formControl} component="fieldset">
               <FormLabel component="legend">¿Se requieren notificaciones?</FormLabel>
               <RadioGroup aria-label="gender" name="gender1" value={formData.isnotified}
                           onChange={e => {
                              const value = e.target.value;
                              setForm(prevFormData => ({
                                 ...prevFormData,
                                 isnotified: value
                              }));
                           }}>
                  <FormControlLabel value="true" control={<Radio />} label="Sí" />
                  <FormControlLabel value="false" control={<Radio />} label="No" />
               </RadioGroup>
            </FormControl>


            <Button
               type="submit"
               fullWidth
               variant="contained"
               color="primary"
               className={classes.button}
               onClick={actionSubmitEvent}
            >
               {formBehavior === VALUES.FORM_BEHAVIOR.EDIT
                  ? TRANSLATE.BUTTONS.EDIT
                  : isSearch
                  ? TRANSLATE.BUTTONS.SEARCH
                  : TRANSLATE.BUTTONS.SAVE}
            </Button>

            <Button
               classes={{
                  root: classes.formCleanButton
               }}
               variant="outlined"
               onClick={cleanForm}
            >
               {TRANSLATE.BUTTONS.CLEAN}
            </Button>
         </form>
      </div>
   )
}

export default FunctionalityForm
